import { render } from "./RoomSettingsForm.vue?vue&type=template&id=b9641fe2"
import script from "./RoomSettingsForm.vue?vue&type=script&lang=js"
export * from "./RoomSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__